
import './MissionPanel.css';

const MissionPanel = () => {
    return null;
};

export default MissionPanel;